import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivityState, Organization, OrganizationActions, OrganizationState, ActivityActions } from '@app/_store';
import { hasActionsExecuting } from '@ngxs-labs/actions-executing';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ActivityItemCardComponent } from '../activity-item-card/activity-item-card.component';

@Component({
  selector: 'app-current-activities',
  templateUrl: './current-activities.component.html',
  styleUrls: ['./current-activities.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, RouterLink, NgFor, ActivityItemCardComponent, AsyncPipe],
})
export class CurrentActivitiesComponent {
  organization$: Observable<Organization> = inject(Store).select(OrganizationState.current);

  currentActivities$: Observable<{ id: string; name: string }[]> = inject(Store).select(ActivityState.currentActivities);

  @Input()
  showButtons = true;

  isLoadingActivities$: Observable<boolean> = inject(Store).select(
    hasActionsExecuting([OrganizationActions.View, ActivityActions.Init])
  );
}
